export {SyncModal, type SyncModalUserProps} from 'src/SyncModal/SyncModal';
